var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF0851",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 17.333a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF0851",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 29.333c5.334-5.333 10.667-10.109 10.667-16 0-5.89-4.776-10.666-10.667-10.666-5.89 0-10.666 4.775-10.666 10.666S10.667 24 16 29.333"
  })));
};
export default SvgPin;